<template>
  <div class="web-box-all">
    <ext-header select_menu="5"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li :class="[menu_select=='0' ? 'select' : '']" @click="set_order_state('0')">
                <a>全部订单</a>
              </li>
              <li :class="[menu_select=='1' ? 'select' : '']" @click="set_order_state('1')" v-if="company_no!='MCD-CHN'">
                <a>待付款</a>
              </li>
              <li :class="[menu_select=='2' ? 'select' : '']" @click="set_order_state('2')">
                <a>配货中</a>
              </li>
              <li :class="[menu_select=='4' ? 'select' : '']" @click="set_order_state('4')">
                <a>待收货</a>
              </li>
              <li :class="[menu_select=='5' ? 'select' : '']" @click="set_order_state('5')" v-if="company_no=='MCD-CHN'">
                <a>待评价</a>
              </li>
              <li :class="[menu_select=='6' ? 'select' : '']" @click="set_order_state('6')">
                <a>已完成</a>
              </li>
            </ul>
          </div>

          <div class="web-order-search">
            <div class="web-order-search-main">
              <div class="web-order-type-select">
                <p style="width:380px; margin-left:15px;">
                  <a>
                    <b-form-datepicker
                      v-model="start_date"
                      :locale="locale"
                      v-bind="labels[locale] || {}"
                      placeholder="开始日期"
                      :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                      type="date" class="mb-2" size="sm"
                    ></b-form-datepicker>
                  </a>
                  <a style="margin-left:10px;">
                    <b-form-datepicker
                      v-model="end_date"
                      :locale="locale"
                      v-bind="labels[locale] || {}"
                      placeholder="结束日期"
                      :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                      type="date" class="mb-2" size="sm"
                    ></b-form-datepicker>
                  </a>
                </p>
                <p style="width:80px;">
                  <b-dropdown size="sm" menu-class="w-100" id="select_type" :text="search_type" style="font-size:12px; width:80px;">
                    <b-dropdown-item @click="select_search_type('产品')" size="sm" href="#">产品</b-dropdown-item>
                    <b-dropdown-item @click="select_search_type('订单')" size="sm" href="#">订单</b-dropdown-item>
                  </b-dropdown>
                </p>
              </div>
              <div class="web-order-input">
                <input type="text" :placeholder="search_type_txt" v-model="search_key" />
              </div>
              <div class="web-order-search-ok" @click="on_search_key()">
                <a style="color:#ffffff">查询</a>
              </div>
            </div>

          </div>

          <div class="web-order-list-box">

            <ext-loading v-if="list_data.length==0" style="width:100%;" title="精彩敬请期待"></ext-loading>

            <div class="web-order-list-data" v-for="(vo,index) in list_data" :key="index">
              <div @click="get_order_show(vo.order_no)" class="web-order-list-title">
                <h2>订单编号：{{vo.erp_order_no!='' ? vo.erp_order_no : vo.order_no}}</h2>
                <p>订单详情<span>（{{vo.order_state_name}}）</span></p>
              </div>
              <div @click="get_order_show(vo.order_no)" class="web-order-list-goods">
                <ul>
                  <li v-for="(voo,key) in vo.goods" :key="key">
                    <img src="@/assets/goods_load.png" v-real-img="web_url+voo.goods_image">
                    <p>
                      <a>{{voo.goods_name}}</a>
                      <b>{{voo.goods_no}}</b>
                    </p>
                    <h2>
                      <a>￥{{voo.price}}</a>
                      <a>x {{voo.qty}}</a>
                    </h2>
                  </li>
                </ul>
              </div>
              <div class="web-order-list-money" @click="get_order_show(vo.order_no)">
                <h2>{{vo.ctime}}</h2>
                <p>订单金额：<span>￥{{vo.pay_money}}</span></p>
                <h5>点击查看详情</h5>
              </div>
              <div class="web-order-list-auto">
                <p>
                  <a @click="get_logistics_info(vo.order_no)" v-if="vo.order_state==4 || vo.order_state==5 || vo.order_state==6">查看物流</a>
                  <a @click="get_sales_return(vo.order_no)" v-if="company_no=='MCD-CHN' && vo.order_state==5 && vo.return_state=='0'">申请退货</a>
                  <a @click="get_sales_return(vo.order_no)" v-if="company_no=='MCD-CHN' && vo.order_state==6 && vo.return_state=='0'">申请退货</a>
                  <a @click="pay_order(vo.order_no)" v-if="company_no!='MCD-CHN' && vo.pay_state==0 && vo.order_state<3">立即付款</a>
                  <a @click="getInvoice(vo.order_no)" v-if="vo.invoice_state=='0' && company_no=='SUB-CHN' && (vo.order_state==5 || vo.order_state==6)">申请发票</a>
                  <a @click="getInvoice(vo.order_no)" v-if="vo.invoice_state!='0' && company_no=='SUB-CHN' && (vo.order_state==5 || vo.order_state==6)">查看发票</a>
                  <a @click="get_order_evaluate(vo.order_no)" v-if="vo.order_state==5">评价</a>
                  <a v-if="vo.order_state==2 && vo.return_state=='1'">退货申请待审核</a>
                  <a @click="buy_again(vo.order_no)" class="red" v-if="vo.order_state==5 || vo.order_state==6">再次购买</a>
                </p>
              </div>
            </div>

          </div>

          <div class="web-order-list-page">
            <b-pagination
              v-model="currentPage"
              :total-rows="list_count"
              :per-page="perPage"
              @change="load_page"
              first-number
              last-number
            >
            <template #prev-text><span class="lemon-page">上一页</span></template>
            <template #next-text><span class="lemon-page">下一页</span></template>
            <template #page="{ page, active }">
              <b class="lemon-page-now" v-if="active">{{ page }}</b>
              <i class="lemon-page-line" v-else>{{ page }}</i>
            </template>
            </b-pagination>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

    <b-modal id="all-order-tip" centered hide-footer>
      <template #modal-title @click="$bvModal.hide('all-order-tip')">
        温馨提示
      </template>
      <div class="d-block text-center">
        <h6 style="text-align: left;">{{messageTipMsg}}</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('all-order-tip')" class="no">确认</a>
      </div>
    </b-modal>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import ExtLoading from '@/components/loading/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'
import qs from 'qs'
import Toast from '@/components/toast/index'

export default {
  name: 'order_list',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-loading': ExtLoading,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '订单列表',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      search_type: '产品',
      order_date: '',
      order_date_list: [],
      search_type_txt: '输入产品描述或号码',
      perPage: 10,
      currentPage: 1,
      list_data: [],
      list_count: 0,
      menu_select: '0',
      search_key: '',
      start_date: '',
      end_date: '',
      toast_state: 'display:none',
      toast_text: '',
      load_text: '',
      locale: 'zh',
      messageTipMsg: '',
      labels: {
        en: {},
        zh: {
          weekdayHeaderFormat: 'narrow',
          labelPrevDecade: '过去十年',
          labelPrevYear: '上一年',
          labelPrevMonth: '上个月',
          labelCurrentMonth: '当前月份',
          labelNextMonth: '下个月',
          labelNextYear: '明年',
          labelNextDecade: '下一个十年',
          labelToday: '今天',
          labelSelected: '√',
          labelNoDateSelected: '未选择日期',
          labelCalendar: '日历',
          labelNav: '日历导航',
          labelHelp: ''
        }
      }
    }
  },
  mounted () {
    var params = this.$route.query
    if (params) {
      if (params.start_date && params.end_date) {
        this.start_date = params.start_date
        this.end_date = params.end_date
      }
    }

    this.load_date()
    this.load_data()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    set_order_state (id) {
      this.menu_select = id
      this.load_data()
    },
    select_search_type (str) {
      this.search_type = str
      if (str === '产品') {
        this.search_type_txt = '输入产品描述或号码'
      } else {
        this.search_type_txt = '输入订单编号'
      }
    },
    select_order_date (str, startDate, endDate) {
      this.order_date = str
      this.start_date = startDate
      this.end_date = endDate
    },
    on_search_key () {
      this.menu_select = '0'
      this.currentPage = 1
      this.load_data()
    },
    get_order_show (orderNo) {
      let routeData = this.$router.resolve({path: '/order/order_show', query: {v: Encrypt(orderNo)}})
      window.open(routeData.href, '_blank')
    },
    get_goods_show (goodsNo) {
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    get_logistics_info (orderNo) {
      this.$router.push({path: '/order/logistics_info', query: {v: Encrypt(orderNo)}})
    },
    get_sales_return (orderNo) {
      this.$router.push({path: '/order/sales_return', query: {v: Encrypt(orderNo)}})
    },
    get_order_evaluate (orderNo) {
      this.$router.push({path: '/order/order_evaluate', query: {v: Encrypt(orderNo)}})
    },
    pay_order (orderNo) {
      var that = this
      ajax({
        url: '/store/api/verify_order_goods',
        method: 'post',
        data: qs.stringify({
          uid: getUserId(),
          order_no: orderNo
        })
      }, function (ret) {
        if (ret) {
          if (ret.code === 'success') {
            that.$router.push({path: '/cart/pay_order', query: {v: Encrypt(orderNo)}})
          } else {
            that.toast(ret.msg)
          }
        }
      })
    },
    getInvoice (orderNo) {
      let that = this
      ajax({
        url: '/store/api/get_invoice?order_no=' + orderNo,
        method: 'post',
        data: {
          uid: getUserId(),
          user_id: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          let type = ret.data.type
          if (type === '1') {
            window.open(ret.data.url)
          } else if (type === '2') {
            window.open(ret.data.pdf_url)
          }
        } else {
          that.messageTipMsg = ret.msg
          that.$bvModal.show('all-order-tip')
        }
      })
    },
    buy_again (orderNo) {
      var that = this
      ajax({
        url: '/store/order/buy_again',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.$router.push({path: '/cart/order_submit', query: {v: Encrypt(ret.data.cart_id), type_id: 2}})
        }
      })
    },
    load_date () {
      var that = this
      ajax({
        url: '/store/order/web_order_date',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.order_date_list = ret.data
          if (ret.data) {
            that.order_date = ret.data['0'].title
          }
        }
      })
    },
    load_page (page) {
      this.currentPage = page
      this.load_data()
    },
    load_data () {
      var that = this
      var page = that.currentPage
      var searchType = this.search_type
      var searchKey = this.search_key
      var startDate = this.start_date
      var endDate = this.end_date

      ajax({
        url: '/store/order/order_list',
        method: 'post',
        data: {
          uid: getUserId(),
          page: page,
          order_state: that.menu_select,
          search_type: searchType,
          search_key: searchKey,
          start_date: startDate,
          end_date: endDate
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_data = ret.data.list_data
          that.list_count = ret.data.list_count
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap;align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:500px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
    .web-order-list-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-search { width:100%; height:50px; margin-top:10px; border:1px solid #dfdfdf; background: #f5f5f5; flex-flow:row; justify-content:space-between;}

    .web-order-search-main { width:auto; height:50px; flex-flow:row; justify-content:flex-start;}
      .web-order-type-select { width:475px; height:50px; flex-flow:row; justify-content:flex-start;}
      .web-order-type-select img { width:20px; height:20px; margin: 16px 7px 0px 15px;}
      .web-order-type-select p { width: auto; height:30px; margin-top:10px; line-height:30px; font-size: 12px; color:#333333;flex-flow:row; justify-content:flex-start;}
      .web-order-type-select p a { width:175px; height:30px; border:0px; display: block; padding:0px !important;}
      .web-order-input { width:170px; height:32px; margin-top:10px; border:1px solid #dfdfdf;}
        .web-order-input input { width:168px; height:30px; line-height:30px; padding-left:10px; font-size:14px; color:#333333; border:0px; margin-top:0px;}
      .web-order-search-ok { width: 100px; height:32px; margin:10px 0px 0px 10px;}
        .web-order-search-ok a { width: 100px; height:32px; cursor: pointer; border-radius: 4px; line-height: 32px; text-align: center; font-size:14px; color:#ffffff;justify-content:center;  background: #d81e06;}
        .web-order-search-ok a:hover { color:#ffffff;}

      .web-order-date-select { width:200px; height:50px; flex-flow:row; justify-content:flex-end;}
      .web-order-date-select p { width: auto; height:30px; margin-top:10px; margin-right:15px; line-height:30px; font-size: 12px; color:#333333;}
      .web-order-date-select p select { border:0px; margin:0px !important; padding:0px !important;}

    .web-order-list-data { width:100%; height:auto; border:1px solid #dfdfdf; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-title { width:100%; height:40px; cursor: pointer; padding:0px 15px; background: #f5f5f5; flex-flow:row; justify-content:space-between;}
      .web-order-list-title h2 { width:auto; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-order-list-title h2 span { width:auto; height:40px; line-height:40px; margin-left:20px; font-size:14px; color:#aaaaaa;}
      .web-order-list-title p { width:auto; height:40px; font-weight: bold; line-height:40px; cursor: pointer; font-size:14px; color:#333333;}
      .web-order-list-title p span { width:auto; height:40px; font-weight: normal;  line-height:40px; font-size:14px; color:#aaaaaa;}
      .web-order-list-goods { width:100%; height:auto; cursor: pointer; flex-wrap:wrap; align-content:flex-start; }
      .web-order-list-goods ul { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; list-style:none; margin:0px; padding:0px;}
      .web-order-list-goods ul li { width:100%; height:90px; flex-flow:row; justify-content:flex-start; margin:0px; padding:15px; border-bottom: 1px solid #dfdfdf;}
      .web-order-list-goods ul li img { width:60px; height:60px; margin-right:20px;}
      .web-order-list-goods ul li p { width:520px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li p a { width:100%; height:40px; line-height:20px; font-size:14px; color:#333333;}
      .web-order-list-goods ul li p a:hover { color:#333333;}
      .web-order-list-goods ul li p b { width:100%; height:20px; font-weight: normal; line-height:20px; font-size:14px; color:#aaaaaa;}
      .web-order-list-goods ul li h2 { width:150px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li h2 a { width:100%; height:20px; line-height:20px; font-size:14px; color:#333333; text-align: right; justify-content:flex-end; }
      .web-order-list-goods ul li h2 a:hover { color:#333333;}
      .web-order-list-money h5 { width:100%; height:20px; position: absolute; top:-20px; left:0px; color:#cccccc; font-size:14px; cursor: pointer; line-height:20px; text-align: center;justify-content:center;}

      .web-order-list-money { width:100%; height:40px; position: relative; flex-flow:row; padding:0px 15px; justify-content:space-between; }
      .web-order-list-money h2 { width:auto; height:40px; line-height:40px; font-size:14px; color:#aaaaaa;}
      .web-order-list-money h2 span { font-size:14px; color:#333333;}
      .web-order-list-money p { width:auto; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-order-list-money p span { color:#d81e06}
      .web-order-list-auto { width:100%; height:50px;  flex-flow:row;justify-content:flex-end; }
      .web-order-list-auto p { width:100%; height:30px; margin-top:5px; flex-flow:row;justify-content:flex-end;  }
      .web-order-list-auto p a { width:100px; height:30px; cursor: pointer; margin-right: 15px; line-height:28px; font-size: 12px;  text-align: center; justify-content: center; border: 1px solid #dfdfdf; color:#333333; border-radius: 4px;}
      .web-order-list-auto p a:hover { color:#333333;}
      .web-order-list-auto p a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
      .web-order-list-auto p a.red:hover { color:#ffffff;}

    .web-order-list-page { width:100%; height:40px; margin-top:20px;}

    .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
    .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
    .lemon-page-line { color:#333333; font-style: normal;}

</style>
<style>
  .text-truncate { text-overflow:initial;}
  .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
  .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
  .lemon-page-line { color:#333333; font-style: normal;}
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
  .btn-sm, .btn-group-sm > .btn { width:auto !important;}
  #select_type button { width:70px !important; text-align: left !important;}
</style>



// WEBPACK FOOTER //
// src/pages/order/order_list.vue